<template>
  <div class="admin-user-form">

    <div class="columns">
      <div class="column is-6">
        <validation-field label="Name" :validation="validation.name">
          <b-input v-model="editUser.name" placeholder="Name" :size="sizeClass" @focus="validation.name.msg = ''" />
        </validation-field>
      </div>
      <div class="column">
        <validation-field label="Username" :validation="validation.username">
          <b-input v-model="editUser.username" placeholder="Username" :size="sizeClass" @focus="validation.username.msg = ''" />
        </validation-field>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <b-field label="Password" :message="newUser ? '' : 'Leave password inputs empty to not change passsword'" :custom-class="sizeClass">
          <b-input type="password" v-model="editUser.password" placeholder="Password" :size="sizeClass" />
        </b-field>
      </div>
      <div class="column">
        <validation-field label="Confirm Password" :validation="validation.confirmPassword">
          <b-input type="password" v-model="editUser.confirmPassword" placeholder="Confirm Password" :size="sizeClass" @focus="validation.confirmPassword.msg = ''" />
        </validation-field>
      </div>
    </div>

    <div class="columns">
      <div class="column is-6">
        <b-message title="Error!" type="is-danger" size="is-small" :active.sync="showErr">{{ errMsg }}</b-message>
      </div>
    </div>

    <div class="buttons">
      <button class="button is-success" :class="{'is-loading': submitting}" @click="submit()">{{ !newUser ? 'Update Admin User' : 'Add Admin User'}}</button>
      <button class="button is-danger" v-if="!newUser" @click="deleteUser()">Delete User</button>
    </div>

  </div>
</template>

<script>
import ValidationField from '@/components/ValidationField'
export default {
  components: {
    ValidationField
  },
  props: ['user'],
  data () {
    return {
      editUser: {},
      sizeClass: 'is-small',
      validation: {
        name: { msg: '' },
        username: { msg: '' },
        confirmPassword: {
          msg: '',
          validate (value, data) {
            return value !== data.password ? 'passwords do not match' : true
          }
        }
      },
      submitting: false,
      showErr: false,
      errMsg: ''
    }
  },
  computed: {
    newUser () { return !this.user || !this.user.id }
  },
  watch: {
    user () { this.prepareUser() }
  },
  created () {
    this.prepareUser()
  },
  methods: {
    submit () {
      if (this.submitting) {
        return
      }
      if (!this.$utils.validate(this.validation, this.editUser)) {
        this.$snackbar.open({
          message: 'User form data invalid!',
          type: 'is-warning',
          position: 'is-bottom',
          indefinite: false
        })
        return
      }
      this.showErr = false
      this.submitting = true
      this.$api(this.newUser ? 'addAdminUser' : 'updateAdminUser', { user: this.editUser })
        .then(resp => {
          this.submitting = false
          this.$snackbar.open({
            message: 'User successfully updated!',
            type: 'is-success',
            position: 'is-bottom',
            indefinite: false
          })
          this.$emit('submitted')
        })
        .catch(err => {
          this.errMsg = `Could not submit user. ${err.toString()}`
          this.showErr = true
          this.submitting = false
        })
    },
    deleteUser () {
      this.$dialog.confirm({
        title: `Delete User`,
        message: 'Are you sure you want to delete this user?',
        cancelText: 'Cancel',
        confirmText: 'Yes',
        type: 'is-danger',
        onConfirm: () => {
          this.$api('deleteAdminUser', { id: this.user.id })
            .then(resp => this.$emit('submitted'))
            .catch(err => {
              this.errMsg = `Could not delete user. ${err.toString()}`
              this.showErr = true
              this.submitting = false
            })
        }
      })
    },
    prepareUser () {
      this.editUser = Object.assign(this.getBlankUser(), this.user || {})
    },
    getBlankUser () {
      return {
        name: '',
        username: '',
        password: '',
        confirmPassword: ''
      }
    }
  }
}
</script>

<style>
</style>
